<template lang="pug">
v-dialog(v-model="value", scrollable, persistent, max-width=640)
  v-card 
    v-card-title.text-center {{ $t('MyBizes.__AddBiz') }}
    v-card-text
      v-form(v-model="formValid", ref="verificationform")
        Alert
        v-text-field.page-input-field(
          v-model.trim="form.name",
          solo,
          dense,
          outlined,
          :rules="[rules.required]",
          :placeholder="$t('ContactInfo.__BizName')"
        )
        v-text-field.page-input-field(
          v-model.trim="form.displayId",
          solo,
          dense,
          outlined,
          :rules="[rules.required]",
          :placeholder="$t('ContactInfo.__2sumupId')"
        )
          template(v-slot:append)
            v-tooltip(right)
              template(v-slot:activator="{ on }")
                v-btn(icon, v-on="on")
                  v-icon info
              div(style="width: 120px") {{ $t('ContactInfo.__IDNote') }}

        v-select(
          v-model="form.type",
          solo,
          dense,
          outlined,
          :rules="[rules.required]",
          item-text="name",
          item-value="value",
          :items="bizTypes",
          :placeholder="$t('ContactInfo.__Industry')"
        )
        CurrencySelector(v-model="form.currencyCode", :rules="[rules.required]", :hint="$t('Auth.__CurrencyNote')")
        TimezoneSelector(v-model="form.timezone", :rules="[rules.required]")
        //- v-text-field.page-input-field(v-model="form.type" item-text="name" item-value="value" solo dense outlined required :rules="[rules.required]" placeholder="公司產業別" )
        v-text-field.page-input-field(v-model.trim="form.taxId", solo, dense, outlined, :placeholder="$t('ContactInfo.__TaxID')")
    v-card-actions.justify-center.mb-6
      v-btn.mr-6(rounded, dark, @click="cancelDialog", color="lightGray", width="112") {{ $t('ActionOption.__Cancel') }}
      v-btn(rounded, color="primary", width="112", @click="start") {{ $t('Auth.__Continue') }}
</template>
<script>
import * as textfieldUtils from "@/utils/textfield.js"

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formValid: true,
      tooltipShow: false,
      rules: textfieldUtils.rules,
      bizTypes: [],
      form: {
        username: "",
        displayId: "",
        name: "",
        type: "",
        taxId: "",
        currencyCode: "",
        timezone: ""
      }
    }
  },
  methods: {
    getBizTypes() {
      this.$store
        .dispatch("bizes/getBizTypes")
        .then(
          function (response) {
            this.bizTypes = response.data.businessTypes
          }.bind(this)
        )
        .catch(
          function (error) {
            this.alertText = error.message
          }.bind(this)
        )
    },
    start() {
      this.$refs.verificationform.validate()
      if (this.formValid) {
        this.updateData()
      }
    },
    async updateData() {
      this.$store.dispatch("global/startLoading")
      var result = await Promise.all([this.createBiz()])
      this.getBiz(result[0].data.businessId)
      this.updateBizes()
      window.location.reload()
    },
    createBiz() {
      return this.$store
        .dispatch("bizes/createBiz", {
          displayId: this.form.displayId,
          name: this.form.name,
          type: this.form.type,
          taxId: this.form.taxId,
          currencyCode: this.form.currencyCode,
          timezone: this.form.timezone
        })
        .then(
          function (result) {
            return Promise.resolve(result)
          }.bind(this)
        )
        .catch(
          function (error) {
            return Promise.reject(error)
          }.bind(this)
        )
    },
    getBiz(bid) {
      this.$store
        .dispatch("bizes/getBiz", bid)
        .then(
          function (response) {
            var biz = response.data
            this.$store.dispatch("bizes/updateBizInfo", biz)
            this.$store.dispatch("account/updateUsedBiz", biz.id)

            this.$store.dispatch("global/stopLoading")
            this.$router.push("/" + this.$i18n.locale + "/dashboard")
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/showAlert", {
              type: "error",
              message: error.message
            })
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    updateBizes() {
      this.$store
        .dispatch("bizes/getBizes", { owned: true })
        .then(
          function (response) {
            this.$store.dispatch("bizes/updateMyBizes", response.data)
          }.bind(this)
        )
        .catch(function (error) { }.bind(this))
    },
    cancelDialog() {
      this.$emit("input", false)
      this.$refs.accountingForm.resetValidation()
    }
  },
  created() {
    this.getBizTypes()
  }
}
</script>
